import axios from "axios";
import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { Loader } from "../Components/Loader";
import { Alert } from "../Components/Modal/Alert";
import { API } from "../Services/Api";
import {
  api_url,
  aplicacao,
  app_base_url,
  enderecos_api,
  itbi_sql_server_url,
  login_api,
} from "../Utils/Urls";
import { useEntidade } from "./EntidadeHook";

interface IUsuarioNaoEmiteNotaContextData {
  login(cpf_cnpj: string, codigo_unico: number): Promise<void>;
  usuarioNaoEmiteNota: UsuarioNaoEmiteNota;
  logoutUsuarioNaoEmiteNota(): void;
}

interface IUsuarioNaoEmiteNotaProviderProps {
  children: ReactNode;
}

const UsuarioNaoEmiteNotaContext = createContext(
  {} as IUsuarioNaoEmiteNotaContextData
);
export const token_storage = "@login-nao-emite-nota";

interface UsuarioNaoEmiteNota {
  CODIGO: number;
  DESCRICAO: string;
  CPF: string;
  CGCMF: string;

}

interface Sistema {
  id: number;
  titulo: string;
  url: string;
  usuario_id: number;
  sistema_id: number;
}

function UsuarioNaoEmiteNotaProvider({
  children,
}: IUsuarioNaoEmiteNotaProviderProps) {
  const { entidade } = useEntidade();
  const [alert, setAlert] = useState({ titulo: "", mensagem: "" });
  const [loading, setLoading] = useState(false);
  const [usuarioNaoEmiteNota, setUsuarioNaoEmiteNota] = useState(
    {} as UsuarioNaoEmiteNota
  );
  const [token, setToken] = useState("");

  function saveToken() {
    localStorage.setItem(token_storage, token);
    API.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    //checarToken();
  }

  async function login(cpf_cnpj: string, codigo_unico: number) {
    try {
      setLoading(true)
      const { data } = await API.post(`/usuario/login-nao-emite-nota`, {
        cpf_cnpj,
        codigo_unico,
        banco: {
          numero: entidade.banco.substring(0, 1),
          banco: entidade.banco.replace("1-", "").replace("2-", ""),
        }
      });


      if (data.status) {

        setUsuarioNaoEmiteNota(data.data.usuario);
        setToken(data.data.token);

        API.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${data.data.token}`;
      } else {
        setAlert({ titulo: "Ops", mensagem: data.mensagem });
      }
    } catch (e) {
      console.log(e);
      setAlert({ titulo: "Ops", mensagem: "Login inválido" });
    } finally {
      setLoading(false)
    }
  }

  async function checarToken() {
    setLoading(true);
    try {
      setLoading(true);
      const token = localStorage.getItem(token_storage);

      if (token) {


        API.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        const { data } = await API.get("/usuario/verifica-token-usuario-nao-emite-nota");
        setUsuarioNaoEmiteNota(data.usuario);

      }
    } catch (error) {
    
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (token && token.length > 0) {
      localStorage.setItem(token_storage, token);
      API.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      checarToken();
      saveToken();
    }

  }, [token]);

  useEffect(() => {
    if (token.length == 0) {
      const _token = localStorage.getItem(token_storage);
      if (_token) {
        setToken(_token)
      }
    }
  }, [])


  function logoutUsuarioNaoEmiteNota() {
    localStorage.removeItem(token_storage);
    setUsuarioNaoEmiteNota({} as UsuarioNaoEmiteNota)
  }


  return (
    <UsuarioNaoEmiteNotaContext.Provider value={{ usuarioNaoEmiteNota, login, logoutUsuarioNaoEmiteNota }}>
      <>
        {children}

        <Loader loading={loading} />
        <Alert
          alert={alert}
          onClose={() => setAlert({ titulo: "", mensagem: "" })}
          open={alert.mensagem.length > 0}
        />
      </>
    </UsuarioNaoEmiteNotaContext.Provider>
  );
}

function useUsuarioNaoEmiteNota() {
  const context = useContext(UsuarioNaoEmiteNotaContext);

  return context;
}

export { UsuarioNaoEmiteNotaProvider, useUsuarioNaoEmiteNota };
